function getUrlPrem(key, url) {
  const search = url || window.location.href;
  const pattern = new RegExp(`[?&]${key}=([^&]+|\\w+)`, 'g');
  const matcher = pattern.exec(search);
  let items = null;
  if (matcher !== null) {
    try {
      items = decodeURIComponent(decodeURIComponent(matcher[1]));
    } catch (e) {
      try {
        items = decodeURIComponent(matcher[1]);
      } catch (error) {
        items = matcher[1];
        console.log(error);
      }
    }
  }
  return items;
}

const bless = {
  state: {
    packagev1: '',
    contentv4: '',
    package_id: '',
    gift_id: '',
    bg_id: '',
    from_type: getUrlPrem('fromType'),
  },
  mutations: {
    SAVE_PACKAGEV4(state, package1) {
      state.contentv4 = package1.content;
      state.package_id = package1.package_id;
      state.gift_id = package1.gift_id;
      state.bg_id = package1.bg_id;
    },
    SAVE_BLESS_FROMTYPE(state, fromtype) {
      state.from_type = fromtype || getUrlPrem('fromType');
    },
  },
};

export default bless;
